module.exports = __webpack_public_path__ + "static/media/hero-wedding.566a3443.png";